export const SITE = {
  name: 'I.M. Distribuzione',
  address: 'Via Agrolatino, 24',
  city: '00030 Labico RM',
  phone: '+393392173787',
  phoneLabel: '339 217 3787',
  whatsappUrl: 'https://wa.me/393392173787',
  mapsUrl: 'https://www.google.com/maps/search/?api=1&query=Via%20Agrolatino%2024%20Labico%20RM',
  mapsEmbedUrl: 'https://www.google.com/maps?q=Via%20Agrolatino%2024%2C%2000030%20Labico%20RM&output=embed'
} as const;
